import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { buildHttpParams } from '../../../core/utils/http-util';
import { environment } from '../../../../environments/environment';
import { endpoints } from '../../core/constants/endpoints';
import {
  IListMemoriesOutput,
  IListMemoriesOutputRaw,
  IMemory,
  IMemoryContentRequest,
  IMemoryRaw,
  IMemorySettings,
  IMemorySettingsRaw,
  toListMemoriesOutput,
  toMemory,
  toMemorySettings,
  toMemorySettingsRaw
} from '../interfaces/memory.interface';

@Injectable({ providedIn: 'root' })
export class MemoriesApi {
  private readonly baseUrl = `${environment.ceppemAiApi}/${endpoints.ceppemAi.memories}`;

  constructor(private http: HttpClient) {}

  list(limit = 100): Observable<IListMemoriesOutput> {
    const params = buildHttpParams({ limit });

    return this.http
      .get<IListMemoriesOutputRaw>(this.baseUrl, { params })
      .pipe(map(toListMemoriesOutput));
  }

  create(request: IMemoryContentRequest): Observable<IMemory> {
    return this.http.post<IMemoryRaw>(this.baseUrl, request).pipe(map(toMemory));
  }

  update(memoryId: string, request: IMemoryContentRequest): Observable<IMemory> {
    return this.http
      .patch<IMemoryRaw>(`${this.baseUrl}/${encodeURIComponent(memoryId)}`, request)
      .pipe(map(toMemory));
  }

  remove(memoryId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${encodeURIComponent(memoryId)}`);
  }

  getSettings(): Observable<IMemorySettings> {
    return this.http
      .get<IMemorySettingsRaw>(`${this.baseUrl}/settings`)
      .pipe(map(toMemorySettings));
  }

  updateSettings(settings: IMemorySettings): Observable<IMemorySettings> {
    return this.http
      .put<IMemorySettingsRaw>(`${this.baseUrl}/settings`, toMemorySettingsRaw(settings))
      .pipe(map(toMemorySettings));
  }
}
